import { render, staticRenderFns } from "./copyClaimOrDispute.vue?vue&type=template&id=8bc70b42&scoped=true"
import script from "./copyClaimOrDispute.vue?vue&type=script&lang=js"
export * from "./copyClaimOrDispute.vue?vue&type=script&lang=js"
import style0 from "./copyClaimOrDispute.vue?vue&type=style&index=0&id=8bc70b42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc70b42",
  null
  
)

export default component.exports